import './link-list.scss';

import { Badge } from '@sola/ark-core/atoms/badge/badge.js';
import { Link } from '@sola/ark-core/atoms/link/link.js';
import { cn } from '@sola/ark-core/utils/helpers.js';
import { ArkIcon } from '@sola/ark-icons/lib/ark-icon.js';
import { NavigationProps } from '@sola/schema/lib/schema.js';

// import { NavigationProps } from '@sola/schema';

type LinkListProps = {
  item: NavigationProps;
  usePadding?: boolean;
  useHover?: boolean;
};

export const LinkList: React.FC<LinkListProps> = ({
  item,
  usePadding = false,
  useHover = false,
}) => {
  const listHasIcon = item?.items?.some((i) => Boolean(i.icon));

  return (
    <ul className="LinkList flex flex-col">
      {item.items?.map((i) => {
        return (
          <li key={i?.title} className="flex gap-snug-xl label items-center">
            <Link
              href={i?.link || '#'}
              target={i?.target}
              title={i?.title}
              className={cn(
                'LinkList__menu-link w-full label-neutral flex gap-snug-xl items-center py-snug-xl',
                {
                  'LinkList__menu-link--hover px-comfy-xs': useHover,
                },
              )}
            >
              {i?.icon && (
                <ArkIcon iconName={i?.icon} className="LinkList__icon" />
              )}

              {usePadding && !listHasIcon && (
                <span className="LinkList__icon" />
              )}

              <span className="LinkList__text flex gap-snug-xl items-center">
                {i?.title}

                {i.badge?.text && (
                  <Badge
                    label={i.badge?.text}
                    color={i.badge?.color}
                    size="sm"
                  />
                )}
              </span>
            </Link>
          </li>
        );
      })}
    </ul>
  );
};
